import { render, staticRenderFns } from "./special_report.vue?vue&type=template&id=6d67a2f1&scoped=true&"
import script from "./special_report.vue?vue&type=script&lang=js&"
export * from "./special_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67a2f1",
  null
  
)

export default component.exports